module.exports = __webpack_public_path__ + "img/img-3-desk.1e271415.jpg";